import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isDisplay'})
export class checkTime implements PipeTransform {
  transform(startTime: any, endTime: any) {
    let currentDate = new Date()
    let startDate: any
    let endDate: any

    startDate = new Date(currentDate.getTime());
    startDate.setHours(startTime.split(":")[0]);
    startDate.setMinutes(startTime.split(":")[1]);
    startDate.setSeconds(startTime.split(":")[2]);

    endDate = new Date(currentDate.getTime());
    endDate.setHours(endTime.split(":")[0]);
    endDate.setMinutes(endTime.split(":")[1]);
    endDate.setSeconds(endTime.split(":")[2]);
    return startDate < currentDate && endDate > currentDate ? 'Yes' : 'No'

  }
}
